<div class="page">
  <div class="page__not-found">
    <span class="page__status">
      {{ isNotFoundPage ? 404 : 403 }}
    </span>
    <div class="page-container">
      <span class="page__message">
        {{ (isNotFoundPage ? 'page.notFound' : 'page.restricted') | translate }}
      </span>
      <span class="page__description">
        {{ (isNotFoundPage ? 'page.wrong' : 'page.doNotHaveAccess') | translate }}
      </span>
      @if (isNotFoundPage) {
        <span class="page__additional-info">{{ 'page.doesNotExist' | translate }}</span>
      } @if (isNotFoundPage) {
      <span class="page__additional-info">{{ 'page.wasDeleted' | translate }}</span>
    }
    </div>
    <p-button class="page__button" [label]="(hasPreviousUrl ? 'page.back': 'page.backMain') | translate"
              (onClick)="back()"></p-button>
  </div>
</div>
